module.exports = {
      id: "cricket-usage",
      viewBox: "0 0 21.217 19.952",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#cricket",
      toString: function () {
        return this.url;
      }
    }